import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Can } from '@/features/acl/can';
import { DialogStateManager } from '@/features/dialog/dialog-provider';
import { useLocale } from '@/lib/hooks/use-locale';
import type { CustomerDTO } from '@/server/dto/customer-dto';
import { ClipboardCheckIcon } from 'lucide-react';
import type { CreateNoteFormProps } from './note-form-dialog';
import { NoteFormDialog } from './note-form-dialog';

export interface DropdownMenuItemCreateNoteProps {
    customer?: CustomerDTO;
    onSuccess?: () => void;
}

export const DropdownMenuItemCreateNote = ({ customer, onSuccess }: DropdownMenuItemCreateNoteProps) => {
    const { t } = useLocale();

    return (
        <Can I="create" a="Note">
            <DropdownMenuItem
                onSelect={() => {
                    DialogStateManager.show(NoteFormDialog, {
                        customer,
                        onSuccess,
                    } satisfies CreateNoteFormProps);
                }}
            >
                <ClipboardCheckIcon className="h-4 w-4" />
                <span>{t('top_navbar__new_note')}</span>
            </DropdownMenuItem>
        </Can>
    );
};
